var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-text-field',{staticClass:"mb-0",attrs:{"id":"alert-description","aria-label":"alert-description","clearable":"","required":"","rules":_vm.requiredRule,"placeholder":_vm.$t('admin.alerts.new.description')},model:{value:(_vm.alertDescription),callback:function ($$v) {_vm.alertDescription=$$v},expression:"alertDescription"}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-52a4afa1","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/settings/alert/alertDescription.vue
// module id = null
// module chunks = 